import type { ConnectionRouteInfo } from '../types/nodeConfig';

export function formatRouteLabel(
  route: ConnectionRouteInfo,
  direction: 'incoming' | 'outgoing',
): string {
  const peer = route.peer_node_name;
  if (direction === 'incoming') {
    return `${route.route_name} ← ${peer}`;
  }
  return `${route.route_name} → ${peer}`;
}
